<template>
  <span :class="tag_classes">
    <slot>{{ value }}</slot>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';

const props = defineProps({
  color: {
    type: String,
    default: STATUS.DEFAULT,
    validator: (value) => Object.values(STATUS).includes(value),
  },
  value: { type: [Number, String], default: null },
  size: {
    type: String,
    default: 'small',
    validator: (value) => ['small', 'medium'].includes(value),
  },
});

const tag_classes = computed(() => {
  const theme = STATUS_COLORS[props.color];
  const size_classes = props.size === 'medium' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs';

  return [
    'inline-flex items-center justify-center rounded-full font-bold',
    theme.COUNT_BG,
    theme.COUNT_TEXT,
    size_classes,
  ];
});
</script>
